import { Injectable } from '@angular/core';
import { AuctionStore } from './auction.store';
import { flattenToAuction } from './models/auction-item.model';
import { tap, map, mapTo } from 'rxjs/operators';
import { AuctionItemViewModel } from './models/auction-item-view.model';
import { ApiService } from '../../shared/services/core/api.service';
import { of } from 'rxjs';
import { AuctionBid } from './models/auction-bid.model';
import { AuctionQuery } from './auction.query';
import { AuctionUpdateMessage } from './models/auction-update-message';
import { MemberQuery } from '../../account/member/member.query';
import { AuctionStatus } from './models/auction-status';
@Injectable({ providedIn: 'root' })
export class AuctionService {

  constructor(private auctionStore: AuctionStore, private api: ApiService, private auctionQuery: AuctionQuery, private memberQuery: MemberQuery) {}

  public fetchAuction(id: number | string) {
    return this.api.getById<AuctionItemViewModel>('auctions', id.toString()).pipe(
      map(a => flattenToAuction(a)),
      tap(a => {
        if (!a) {
          this.auctionStore.remove(id);
        } else {
          this.auctionStore.upsert(id, a);
        }
      }),
      mapTo(null)
    );
  }

  fetchAuctions() {
    const request$ = this.api.get<AuctionItemViewModel>('auctions').pipe(
      map(a => a.map(auction => flattenToAuction(auction))),
      tap(a => {
        this.auctionStore.set(a);
      }),
      mapTo(null)
    );
    return this.auctionQuery.getHasCache() ? of(null) : request$;
  }

  public postBid(bid: AuctionBid, memberId: string = '') {
    return this.api.postForParent<number>('auctions', bid.auctionId, 'bid?memberId=' + memberId, bid.value).pipe(
      map(a => flattenToAuction(a)),
      tap(a => this.auctionStore.upsert(a.Id, a)),
      mapTo('bid successful')
    );
  }

  updateAuctionAfterBid(auctionUpdate: AuctionUpdateMessage) {

    let portalId = this.memberQuery.getUserContext().portalId;

    this.auctionStore.update(auctionUpdate.auctionId, entity => ({
      CurrentValue: auctionUpdate.currentValue,
      BidsCount: auctionUpdate.bidCount,
      EndDate: auctionUpdate.endDate,
      IsWinning: portalId === auctionUpdate.winningPortalId ? 1 : 0,
      Status: portalId === auctionUpdate.winningPortalId ? AuctionStatus.UserWinning :
                        entity.HasUserBidOnAuction === true ? AuctionStatus.UserLosing : AuctionStatus.UserNotBid,
      HasUserBidOnAuction: portalId === auctionUpdate.winningPortalId ? true : entity.HasUserBidOnAuction,
      HasPreviousSuccessfulBid: true
      })
    );
  }
}
